import api from '@/apis'
import Vuetify from '@/plugins/vuetify'
import downloader from 'js-file-download'

import generator from 'generate-password'

export default {
  state: {
    visibility: true,
    routes: [
      { title: 'Dashboard', icon: 'mdi-view-dashboard', path: '/dashboard' },
      { title: 'Chat', icon: 'mdi-chat', path: '/chat' },
      { title: 'Live Video', icon: 'mdi-video', path: '/live_video' },
      { title: 'Message', icon: 'mdi-message', path: '/message' },
      { title: 'AI Configuration', icon: 'mdi-database-cog', path: '/ai' },
      { title: 'Small Talk', icon: 'mdi-chat-processing', path: '/talk' },
      { title: 'Conversation Review', icon: 'mdi-comment-search', path: '/conversation' },
      { title: 'Event Manager', icon: 'mdi-stadium', path: '/event' },
      { title: 'Interface Settings', icon: 'mdi-monitor', path: '/interface' },
      { title: 'Admin Settings', icon: 'mdi-account-cog', path: '/setting' }
    ],
    backup: {
      visibility: false,
      password: ''
    }
  },
  mutations: {
    SET_LEFTBAR_VISIBILITY(state) {
      state.visibility = !state.visibility
    },
    SET_LEFTBAR_BACKUP_VISIBILITY(state, payload) {
      state.backup.visibility = payload
    },
    SET_LEFTBAR_BACKUP_PASSWORD(state, payload) {
      state.backup.password = payload
    }
  },
  actions: {
    async downloadBackup({ rootState, commit }) {
      try {
        commit('SET_SNACKBAR', { status: true, color: 'loading', text: Vuetify.locale.t('$vuetify.__SnackBar.downloading'), loading: true })
        const device_id = rootState.auth.selected_device
        const zip_password = generator.generate({
          length: 10,
          numbers: true
        })
        commit('SET_LEFTBAR_BACKUP_PASSWORD', zip_password)
        const params = { device_id, zip_password }
        const headers = { responseType: 'arraybuffer' }
        const response = await api.getBackup({ params, headers })

        if (response.data) {
          const filename = response.headers['content-disposition'].split('filename=')[1]
          var blob = new Blob([response.data], { type: 'application/zip' })
          downloader(blob, filename)

          commit('SET_LEFTBAR_BACKUP_VISIBILITY', true)
          commit('SET_SNACKBAR', { status: true, color: 'success', text: Vuetify.locale.t('$vuetify.__SnackBar.download'), icon: 'check', timeout: '2000' })
        } else throw Error(response.data.message)
      } catch (error) {
        commit('SET_SNACKBAR', { status: true, color: 'error', text: error.message, icon: 'close', timeout: '2000' })
      }
    }
  }
}
